import React from "react";
import ContentSection from "../content-section";
import HitsRowsSkeleton from "../hits/hits-rows-skeleton";

const News: React.FunctionComponent<any> = (): JSX.Element => {
  return (
    <>
      <ContentSection
        heading="Så gör andra"
        description="Du behöver inte uppfinna hjulet själv! Här kan du hitta tips och inspiration från andra arbetsplatser, som kanske har samma utmaningar som ni."
        facetFilters={["types:Så gör andra"]}
        hitsPerPage={5}
        defaultDisplayMode="infinite-rows"
        compact={true}
        skeleton={<HitsRowsSkeleton items={5} />}
        showDisplayMode={false}
        anchorName="sa-gor-andra"
        sortBy="create_date:desc,title_sort:asc"
      />
      <ContentSection
        heading="Vad säger forskningen?"
        description="Arbetsmiljöforskare arbetar ständigt med att ta reda på vad som bidrar till friska arbetsplatser - samtidigt som världen förändras. Här får du veta vad de kommit fram till."
        facetFilters={["types:forskning"]}
        hitsPerPage={5}
        defaultDisplayMode="infinite-rows"
        compact={true}
        skeleton={<HitsRowsSkeleton items={5} />}
        showDisplayMode={false}
        anchorName="forskning"
        sortBy="create_date:desc,title_sort:asc"
      />
      <ContentSection
        heading="Nyheter"
        description="Häng med på vad som händer på arbetsmiljöfronten! Uppdatera dig på nyheter, få rapporter från seminarier och läs om intressanta händelser i arbetsmiljövärlden."
        facetFilters={["types:nyheter"]}
        hitsPerPage={5}
        defaultDisplayMode="infinite-rows"
        compact={true}
        skeleton={<HitsRowsSkeleton items={5} />}
        showDisplayMode={false}
        anchorName="nyheter"
        sortBy="create_date:desc,title_sort:asc"
      />
    </>
  );
};

export default News;
